import { createContext } from "react";

export default createContext<number>(0);
